import styled from 'styled-components';

export const PanelDetails = styled.details`
	margin-top: 12px;
	border: 1px solid #d8dde4;
	border-radius: 8px;
	background: #fafbfc;
	padding: 12px 16px;
	color: #2b3340;

	&[open] > summary {
		margin-bottom: 12px;
	}
`;

export const PanelSummary = styled.summary`
	cursor: pointer;
	font-weight: 600;
	list-style: none;

	&::-webkit-details-marker {
		display: none;
	}

	&::before {
		content: '▸';
		display: inline-block;
		margin-right: 8px;
		transition: transform 0.15s ease;
	}

	${PanelDetails}[open] &::before {
		transform: rotate(90deg);
	}
`;

export const PanelSection = styled.section`
	margin-top: 12px;
	color: #2b3340;

	h4 {
		margin: 0 0 6px 0;
		font-size: 13px;
		text-transform: uppercase;
		letter-spacing: 0.04em;
		color: #5b6470;
	}

	ul {
		margin: 0;
		padding-left: 20px;
		font-size: 14px;
		color: #2b3340;
	}

	li + li {
		margin-top: 2px;
	}

	p {
		margin: 0 0 8px 0;
		font-size: 14px;
		color: #5b6470;
	}
`;

export const Pill = styled.span<{ tone?: 'warn' }>`
	display: inline-block;
	padding: 2px 8px;
	margin-right: 4px;
	border-radius: 999px;
	font-size: 12px;
	background: ${({ tone }) => (tone === 'warn' ? '#fff4e5' : '#eef1f5')};
	color: ${({ tone }) => (tone === 'warn' ? '#a35a00' : '#2b3340')};
`;

export const Row = styled.div`
	display: flex;
	gap: 24px;
	flex-wrap: wrap;
`;

export const Stat = styled.div<{ tone?: 'warn' }>`
	display: flex;
	flex-direction: column;

	b {
		font-size: 20px;
		color: ${({ tone }) => (tone === 'warn' ? '#a35a00' : '#2b3340')};
	}

	span {
		font-size: 12px;
		color: #5b6470;
	}
`;
